export const en = {
    'audio-title': 'Audio library'
};
